import paymentInThread from "venuescanner-js/react/components/Inbox/helpers/paymentInThread";

export function Payment({ thread, message, cumulative }) {
  return isEventFullyPaid(thread, message, cumulative)
    ? "Event fully paid"
    : "";
}

function isEventFullyPaid(thread, message, cumulative) {
  const payment = paymentInThread({ thread, paymentID: message.payment });

  if (!payment) return false;

  return cumulative.outstanding - payment.amountInPence / 100 <= 0;
}
